import { useEqualState } from "./state/use-equal-state";
import { useEffect } from "react";

export function useSyncedEqualState<S>(state: S): S {
  const [synced, setSynced] = useEqualState(state);

  useEffect(() => {
    setSynced(state);
  }, [state]);

  return synced;
}
